require('./bootstrap');


//require jquery
//global.$ = global.jQuery = require('jquery');


import jQuery from 'jquery';
window.$ = jQuery;
window.jQuery = jQuery;
import 'jquery-ui/ui/widgets/sortable';
import 'select2';
